var v1 = require('./v1');
var v4 = require('./v4');

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;



//////////////////
// WEBPACK FOOTER
// /Users/bvzk/Local Sites/xpansiv/app/public/wp-content/themes/xpansiv-wordpress/node_modules/uuid/index.js
// module id = 10
// module chunks = 0